import { useScrollCtx } from "@/providers/AppProviders";
import { content } from "@/lib/content";

export const Footer = () => {
  const { scrollToProgress } = useScrollCtx();
  const f = content.frame6.footer;
  const targets = [0.01, 0.4, 0.57, 0.93];
  return (
    <div className="pb-8">
      <div className="text-plate mx-auto max-w-5xl px-7 py-5">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
          <p className="text-sm text-foreground">{f.tagline}</p>
          <nav className="flex items-center gap-5">
            {f.links.map((l, i) => (
              <button
                key={l}
                onClick={() => scrollToProgress(targets[i])}
                data-cursor="hover"
                className="text-sm text-muted-foreground transition-colors hover:text-foreground"
              >
                {l}
              </button>
            ))}
          </nav>
        </div>
        <p className="mt-3 text-center text-xs text-muted-foreground">
          {f.copyright}
        </p>
      </div>
    </div>
  );
};
